module.exports = __webpack_public_path__ + "dcac-8c814f29.webp";